import React from 'react';
import { MdInfoOutline } from 'react-icons/md';

interface Props {
  children: React.ReactNode;
}

function LocationInfoAlert({ children }: Props) {
  return (
    <div className="bg-[#E9F6FF] p-3 lg:p-[14px] flex gap-3 items-center mt-2">
      <div>
        <MdInfoOutline color="#036EBC" size={22} />
      </div>

      <div>{children}</div>
    </div>
  );
}

export default LocationInfoAlert;
